import { FC, useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Box, Modal, Typography } from '@mui/material';
import { Form } from 'react-router-dom';

import Plans from '../../../../../components/Plans';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux';
import CustomButton from '../../../../../common/CustomButton';
import RunOut from '../../../../../assets/images/runOut.png';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Subscription.module.scss';
import { useSubscriptionCheckoutMutation } from '../../../../../store/services/customizeOptionsApi';
import { setSelectedPlanId } from '../../../../../store/slices/planSlice';

type FormikValues = {
  plan: number;
};

const Subscription: FC = () => {
  const dispatch = useAppDispatch();
  const [stayConnected, setStayConnected] = useState(false);
  const [subscriptionCheckout] = useSubscriptionCheckoutMutation();
  const plan = useAppSelector(state => state.plan);

  const initialValues = {
    plan: plan.plan || 0,
  };

  const handleSubmit = (values: FormikValues) => {
    localStorage.setItem('createAccount', JSON.stringify(values));
  };

  const formikValidate = (values: FormikValues) => {
    const errors: Partial<FormikValues> = {};

    return errors;
  };

  useEffect(() => {
    if (!plan.ends_at) return;

    const now = new Date();
    const endDate = new Date(plan.ends_at);
    const diffMs = endDate.getTime() - now.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays <= 30 && diffDays > 0) {
      setStayConnected(true);
    }
  }, [plan.ends_at]);

  const renewNow = async () => {
    try {
      const data = await subscriptionCheckout({ plan_id: plan.plan }).unwrap();
      if (data.checkout_url) {
        window.location.assign(data.checkout_url);
      }
      dispatch(setSelectedPlanId({ id: plan.plan }));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box className={styles.subscriptionTab}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validate={formikValidate}
        onSubmit={handleSubmit}
      >
        {({ values, errors, handleChange, isSubmitting }) => (
          <Form>
            <Plans
              values={values}
              hideHeader={true}
              onChangePlan={handleChange}
              subscription
            />
          </Form>
        )}
      </Formik>
      <Modal
        open={stayConnected}
        onClose={setStayConnected}
        aria-labelledby="stayConnected"
        aria-describedby="stayConnected"
      >
        <Box className={styles.modalContentWrapper}>
          <Box sx={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <CloseIcon onClick={() => setStayConnected(false)} />
          </Box>
          <img
            src={RunOut}
            alt="Stay connected"
          />
          <Typography
            variant="h5Bold"
            sx={{ color: '#222B3A' }}
          >
            Stay connected to all your smart features
          </Typography>
          <Typography
            variant="h10"
            sx={{ color: '#222B3A' }}
          >
            You have 30 days left of full access. Renew now to keep unlimited document storage, advanced tools, and full
            control over your data — without interruptions.
          </Typography>
          <CustomButton
            onClick={renewNow}
            customClass={styles.btn}
          >
            Renew Now
          </CustomButton>
        </Box>
      </Modal>
    </Box>
  );
};

export default Subscription;
